
import { useState } from "react";
import { Grid, MenuItem, TextField } from "@mui/material";
import { BotonesAndCargando } from "../botones/BotonesAndCargando";
import { useProveedoresQuery } from "../../../hooks";
import { InputSeparadorDecimal } from "../inputs/InputSeparadorDecimal";
import { DateFormScreen } from "../inputs/DateFormScreen";
import { startSavingFacturas } from "../../../services";
import { useModalesStore } from "../../../store";

import Swal from "sweetalert2";



export const FormularioCrearFactura = ({ selected, setItemsFinal }) => {

    const { proveedoresListQuery } = useProveedoresQuery();
    const { changeEstadoModalUno } = useModalesStore(); 
    const totalFactura = selected.reduce((acc, item) => acc + (item.total || 0), 0);
    const [formValues, setFormValues] = useState({numero: '', proveedor: '', total: totalFactura, formaPago: '', fecha: ''});
    const { numero, proveedor, formaPago, fecha } = formValues;
    const [cargando, setCargando] = useState(false);


    const handleChanges = ({ target: { name, value } }) => {
        setFormValues(prev => ({ ...prev, [name]: value }));
    };



    const crearActInformacion = async(e) => {
        e.preventDefault();
        if(Object.values(formValues).includes('') ){
            return Swal.fire('Error', 'Formulario Incorrecto por favor llene todos los campos', 'error');
        }

        const result = await Swal.fire({
            title: `Crear Factura`,
            text: `¿Esta seguro de Crear Factura?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: `Si Crear`,
            cancelButtonText: 'Cancelar'
        });
        
        if (!result.isConfirmed) return;
        
        setCargando(true);
        const resp = await startSavingFacturas({ ...formValues, productos:selected });
        setCargando(false);
        if(resp){ 
            changeEstadoModalUno(false);
            setItemsFinal([]); 
        }
    }


    

    return (
        <form onSubmit={ crearActInformacion } >
            <Grid container spacing={2}>

                <Grid item xs={12}>
                    <DateFormScreen
                        label="Fecha de Factura" 
                        placeholder='Fecha de Factura' 
                        value={fecha} 
                        onChange={ handleChanges } 
                        name='fecha'
                    />
                </Grid>


                <Grid item xs={12}>
                    <TextField
                        type="text"
                        label='Numero de Factura'
                        fullWidth
                        size="small"
                        name='numero'
                        value={ numero }
                        onChange={ handleChanges }
                    />
                </Grid>
                
                {(proveedoresListQuery?.data?.length > 0) &&
                <Grid item xs={12}>
                    <TextField
                        size="small"
                        select
                        label="Proveedor"
                        fullWidth
                        name='proveedor'
                        value={ proveedor }
                        onChange={handleChanges}
                    >
                        <MenuItem value="">Seleccione Proveedor</MenuItem>
                        {Array.isArray(proveedoresListQuery?.data) && proveedoresListQuery.data.length > 0 ? (
                            proveedoresListQuery.data.map((g) => (
                                <MenuItem key={g.id} value={g.id}> {g.nombre} </MenuItem>
                            ))
                        ) : (
                            <MenuItem disabled>No hay proveedores disponibles</MenuItem>
                        )}
                    </TextField>
                </Grid>
                }

                <Grid item xs={12}>
                    <TextField
                        size="small"
                        select
                        label="Forma de Pago"
                        fullWidth
                        name='formaPago'
                        value={ formaPago }
                        onChange={ handleChanges }
                    >
                        <MenuItem value=''>Seleccione Forma de Pago</MenuItem>
                        <MenuItem value='CREDITO'>CREDITO</MenuItem>
                        <MenuItem value='CONTADO'>CONTADO</MenuItem>
                    </TextField>
                </Grid>

                <Grid item xs={12}>
                    <InputSeparadorDecimal
                        disabled={true}
                        size="small"
                        label='Total'
                        placeholder='Total'
                        fullWidth
                        name='total'
                        value={ totalFactura }
                    />
                </Grid>
            </Grid>


            <Grid container sx={{mt:3, mb:2, display:'flex', justifyContent:'center' }}>
                <Grid item xs={12} sm={6} md={5}>
                    <BotonesAndCargando
                        cargando={cargando}
                        titulo={'Crear'}
                        titulo2="Loading..."
                        icon1="save"
                        icon2="save"
                        type="submit"
                    />
                </Grid>
            </Grid>
        </form>
    )
}
